import { NativeApi } from "@accurx/native";

import { createEndpoint } from "../createEndpoint";

export type MutateSupportLinkClickPayload = {
    uri: string;
};

export const mutateSupportLinkClick = createEndpoint<
    unknown,
    MutateSupportLinkClickPayload
>("MutateSupportLinkClick", async (context, payload) => {
    await NativeApi.request({
        transport: context.transport,
        request: {
            type: "MutateSupportLinkClick",
            workspaceId: context.workspaceId,
            payload: payload,
        },
    });
});
